'use client';

import { c as _c } from "react/compiler-runtime";
import '@maptiler/sdk/dist/maptiler-sdk.css';
import { type Map } from '@maptiler/sdk';
import * as maptilersdk from '@maptiler/sdk';
import { type LngLatLike } from 'maplibre-gl';
import { useEffect, useRef } from 'react';
import { useIsMounted } from 'usehooks-ts';
import mapStyle from '@/features/listing/components/listings-map/map/map-style';
import styles from './listing-detail-map.module.scss';
interface ListingDetailMapProps {
  coordinates: LngLatLike;
}
export default function ListingDetailMap(props) {
  const $ = _c(6);
  const {
    coordinates
  } = props;
  const isMounted = useIsMounted();
  const map = useRef(null);
  const mapContainer = useRef(null);
  let t0;
  if ($[0] !== coordinates) {
    t0 = () => {
      if (map.current) {
        return;
      }
      map.current = new maptilersdk.Map({
        center: coordinates,
        container: mapContainer.current,
        geolocateControl: false,
        interactive: false,
        navigationControl: false,
        style: mapStyle,
        target: mapContainer.current,
        zoom: 14
      });
      map.current.on("load", () => {
        if (map.current) {
          map.current.addSource("planet", {
            tiles: ["https://map.roomster.com/data/v3/{z}/{x}/{y}.pbf?key=oxQ5YeTFJ13jkTv9eIN9pB67cKSSFhsV"],
            type: "vector"
          });
        }
      });
      new maptilersdk.Marker().setLngLat(coordinates).addTo(map.current);
    };
    $[0] = coordinates;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== coordinates || $[3] !== isMounted) {
    t1 = [coordinates, isMounted];
    $[2] = coordinates;
    $[3] = isMounted;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.listingDetailMap}><div className={styles.listingDetailMap} ref={mapContainer} /></div>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}